import PropTypes from 'prop-types';

import { DSIcon } from '@spotahome/ui-library/base';

import './PropertyTitle.scss';

const PropertyDescriptionItem = ({ value, text, iconName = '' }) => (
  <div className="property-description-item">
    {iconName && (
      <DSIcon name={iconName} className="property-title__icon" size="s" />
    )}
    <strong className="property-description-item__value">{value}</strong> {text}
  </div>
);

PropertyDescriptionItem.propTypes = {
  value: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  iconName: PropTypes.string
};

export default PropertyDescriptionItem;
